import React from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { API, useAuth } from "@/context/AuthContext";

// Inline SVG flags — lightweight, no extra dependency
const FlagNL = ({ className = "w-5 h-3.5" }) => (
  <svg className={className} viewBox="0 0 9 6" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <rect width="9" height="2" fill="#AE1C28" />
    <rect y="2" width="9" height="2" fill="#FFFFFF" />
    <rect y="4" width="9" height="2" fill="#21468B" />
  </svg>
);

const FlagLT = ({ className = "w-5 h-3.5" }) => (
  <svg className={className} viewBox="0 0 9 6" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <rect width="9" height="2" fill="#FDB913" />
    <rect y="2" width="9" height="2" fill="#006A44" />
    <rect y="4" width="9" height="2" fill="#C1272D" />
  </svg>
);

export default function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const { user, refresh } = useAuth() || {};
  const current = i18n.resolvedLanguage || i18n.language || "nl";

  const change = async (lng) => {
    i18n.changeLanguage(lng);
    try { localStorage.setItem("app_lang", lng); } catch (err) { /* noop */ }
    // If logged in, persist to backend so preference syncs across devices
    if (user && user.id) {
      try {
        await axios.put(`${API}/users/me/language`, { language: lng });
        if (typeof refresh === "function") refresh();
      } catch (err) {
        // Non-fatal: local switch already applied
        // eslint-disable-next-line no-console
        console.warn("LanguageSwitcher: could not persist to backend", err);
      }
    }
  };

  const btn = (code, Flag, label) => (
    <button
      onClick={() => change(code)}
      className={`flex items-center gap-1.5 px-2 py-1 rounded-sm text-xs font-medium border transition ${
        current === code
          ? "bg-zinc-900 text-white border-zinc-900"
          : "bg-white text-zinc-700 border-zinc-200 hover:bg-zinc-100"
      }`}
      aria-label={label}
      aria-pressed={current === code}
      data-testid={`lang-btn-${code}`}
    >
      <Flag />
      <span className="uppercase tracking-wide">{code}</span>
    </button>
  );

  return (
    <div className="flex items-center gap-1" role="group" aria-label={t("common.language")}>
      {btn("nl", FlagNL, t("language.nl"))}
      {btn("lt", FlagLT, t("language.lt"))}
    </div>
  );
}
